import request from '@/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/emp-business/alarmEvent/list',
    method: 'get',
    filterEmptyParams: true,
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getPage = (current, size, params) => {
  return request({
    url: '/emp-business/alarmEvent/page',
    method: 'get',
    filterEmptyParams: true,
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/emp-business/alarmEvent/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/emp-business/alarmEvent/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const handleReduce = (ids, handleType) => {
  return request({
    url: '/emp-business/alarmEvent/handle',
    method: 'post',
    params: {
      ids,
      handleType,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/emp-business/alarmEvent/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/emp-business/alarmEvent/update',
    method: 'post',
    data: row
  })
}

// 获取告警数
export const getAlarmingCount = () => {
  return request({
    url: '/emp-business/alarmEvent/alarmingCount',
    method: 'get'
  })
}